<template>
  <v-app>
    <v-app-bar app extended extension-height="0" clipped-right>
      <v-app-bar-nav-icon class="pl-1" :to="'/'">
        <div class="v-icon">
          <img src="@/assets/favicon.png" alt="Logo" height="32px" />
        </div>
      </v-app-bar-nav-icon>
      <v-toolbar-title class="fh-cursor-pointer pl-1">
        <router-link :to="{ name: 'estado_cuentas' }" class="fh-link">
          Consulta de Cuentas
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items v-if="!mobile">
        <fh-menu-operador></fh-menu-operador>
      </v-toolbar-items>

      <v-app-bar-nav-icon
        v-else
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <fh-progress slot="extension"></fh-progress>
    </v-app-bar>

    <v-navigation-drawer
      app
      v-if="mobile"
      right
      v-model="drawer"
      clipped
      width=""
      class="mx-auto"
    >
      <v-list>
        <v-list-item>
          <v-list-item-title class="text-subtitle-1">{{
            nombreOperador
          }}</v-list-item-title>
        </v-list-item>
        <v-list-item :href="configurationUrl" target="_blank">
          <v-list-item-action class="mr-1">
            <v-icon small>mdi-cog</v-icon>
          </v-list-item-action>
          <v-list-item-title>Configuraciones</v-list-item-title>
        </v-list-item>
        <v-list-item @click="handleLogout">
          <v-list-item-action class="mr-1">
            <v-icon small>mdi-power</v-icon>
          </v-list-item-action>
          <v-list-item-title>Cerrar Sesión</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
      <v-list dense rounded>
        <v-list-item
          :to="{ name: 'estado_cuentas' }"
          active-class="primary white--text"
        >
          <v-list-item-content>
            <v-list-item-title class="text-none">
              Estado de Cuentas
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'cuenta_corriente' }"
          active-class="primary white--text"
          :class="cuentaCorrienteActive"
        >
          <v-list-item-content>
            <v-list-item-title class="text-none">
              Cuenta Corriente
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="existenPrestamos"
          :to="{ name: 'prestamos' }"
          active-class="primary white--text"
          :class="prestamosActive"
        >
          <v-list-item-content>
            <v-list-item-title class="text-none"> Préstamos </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="existenciaPlazosFijos"
          :to="{ name: 'plazo_fijo' }"
          active-class="primary white--text"
        >
          <v-list-item-content>
            <v-list-item-title class="text-none">
              Plazo Fijo
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="existenFacturas"
          :to="{ name: 'factura_credito' }"
          active-class="primary white--text"
        >
          <v-list-item-content>
            <v-list-item-title class="text-none">
              Factura Crédito
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="existenEstudiantes"
          :to="{ name: 'becas' }"
          active-class="primary white--text"
        >
          <v-list-item-content>
            <v-list-item-title class="text-none"> Becas </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'extractos_historico' }"
          active-class="primary white--text"
        >
          <v-list-item-content>
            <v-list-item-title class="text-none">
              Extractos históricos
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-card class="fill-height">
        <v-card-text>
          <v-container>
            <v-row justify="center">
              <v-col lg="10" xl="8">
                <div v-if="!mobile" class="mb-5">
                  <v-btn
                    class="text-none fh-active-button"
                    text
                    :to="{ name: 'estado_cuentas' }"
                    active-class="primary"
                  >
                    Estado de Cuentas
                  </v-btn>
                  <v-btn
                    class="text-none fh-active-button"
                    text
                    :to="{ name: 'cuenta_corriente' }"
                    active-class="primary"
                    :class="cuentaCorrienteActive"
                  >
                    Cuenta Corriente
                  </v-btn>
                  <v-btn
                    v-if="existenPrestamos"
                    class="text-none fh-active-button"
                    text
                    :to="{ name: 'prestamos' }"
                    active-class="primary"
                    :class="prestamosActive"
                  >
                    Préstamos
                  </v-btn>
                  <v-btn
                    v-if="existenciaPlazosFijos"
                    class="text-none fh-active-button"
                    text
                    :to="{ name: 'plazo_fijo' }"
                    active-class="primary"
                  >
                    Plazo Fijo
                  </v-btn>
                  <v-btn
                    v-if="existenFacturas"
                    class="text-none fh-active-button"
                    text
                    :to="{ name: 'factura_credito' }"
                    active-class="primary"
                  >
                    Factura Crédito
                  </v-btn>
                  <v-btn
                    v-if="existenEstudiantes"
                    class="text-none fh-active-button"
                    text
                    :to="{ name: 'becas' }"
                    active-class="primary"
                  >
                    Becas
                  </v-btn>
                  <v-btn
                    class="text-none fh-active-button"
                    text
                    :to="{ name: 'extractos_historico' }"
                    active-class="primary"
                  >
                    Extractos históricos
                  </v-btn>
                </div>
                <router-view></router-view>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-main>

    <fh-snackbar></fh-snackbar>
  </v-app>
</template>

<script>
import FhMenuOperador from "@/components/FhMenuOperador";
import FhProgress from "@/components/FhProgress";
import FhSnackbar from "@/components/FhSnackbar";
import { mapActions, mapState } from "vuex";
import SessionService from "@/services/SessionService";
import { CONFIGURATION_URL, LOGOUT_URL, SITE_NAME } from "@/config";

export default {
  name: "App",
  components: { FhSnackbar, FhProgress, FhMenuOperador },
  data: () => ({
    listaAnios: [],
    mobile: window.innerWidth <= 700,
    drawer: null,
  }),
  methods: {
    ...mapActions("prestamo", ["fetchTieneResumenPrestamos"]),
    generarListaAnios() {
      let fechaActual = new Date();
      let anioActual = parseInt(fechaActual.getFullYear());
      for (let anio = anioActual; anio >= anioActual - 2; anio--) {
        this.listaAnios.push(anio);
      }
    },
    handleLogout() {
      location.href = `${LOGOUT_URL}?nombre=${SITE_NAME}&redirect=${location.origin}`;
    },
  },
  computed: {
    ...mapState("valores", [
      "listaPlazoFijoEntidad",
      "listaPrestamosEntidad",
      "listaFacturaCreditoResumen",
      "listaEstudiantes",
    ]),
    ...mapState("prestamo", ["tieneResumenPrestamos"]),
    nombreOperador() {
      return SessionService.getNombreOperador();
    },
    configurationUrl() {
      return CONFIGURATION_URL;
    },
    existenEstudiantes() {
      if (this.listaEstudiantes === undefined) {
        return false;
      }
      return this.listaEstudiantes.length > 0;
    },
    existenFacturas() {
      if (this.listaFacturaCreditoResumen === undefined) {
        return false;
      }
      return this.listaFacturaCreditoResumen.length > 0;
    },
    existenciaPlazosFijos() {
      if (this.listaPlazoFijoEntidad === undefined) {
        return false;
      }
      return this.listaPlazoFijoEntidad.length > 0;
    },
    existenPrestamos() {
      if (this.listaPrestamosEntidad === undefined) {
        return false;
      }
      if (this.listaPrestamosEntidad.length > 0) {
        return true;
      }
      return this.tieneResumenPrestamos;
    },
    cuentaCorrienteActive() {
      if (
        this.$route.name === "cuenta_resumen" ||
        this.$route.name === "resumen_anual"
      ) {
        return ["primary"];
      }

      return [];
    },
    prestamosActive() {
      if (this.$route.name === "prestamos-cronograma") {
        return ["primary"];
      }

      return [];
    },
  },
  async mounted() {
    this.generarListaAnios();
    await this.fetchTieneResumenPrestamos([
      this.listaAnios[this.listaAnios.length - 1],
      this.listaAnios[0],
    ]);
  },
  created() {
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 700;
    });
  },
};
</script>

<style scoped>
.fh-active-button.v-btn--active::before {
  opacity: 0;
}

.fh-link {
  text-decoration: none;
}

.v-application a {
  color: #000000;
}
/* Extend progress indicator over whole toolbar */
/*noinspection CssUnusedSymbol*/
.v-toolbar >>> .v-toolbar__extension {
  padding: 0;
}
</style>

<style>
/* Striped table */
tbody tr:nth-child(odd) {
  background-color: #f5f5f5;
}

/* Internet Explorer doesn't set the width of rows per page correctly
   https://github.com/vuetifyjs/vuetify/issues/9527 */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .v-menu__content .v-list-item {
    min-width: 80px;
  }

  .v-data-footer__select .v-input__slot {
    min-width: 70px;
  }

  .v-data-footer__select {
    padding-right: 70px;
  }
}
</style>
